import { BaseService } from './base.service';
import { HeaderNotification } from '../models/generic';
import { Uris } from '../common/constants';

export interface INotificationService {
  getNotifications: (param: any) => any
  getUnreadNotification: (param: any) => any
  markAsRead: (id: string) => Promise<any>
  markAsReadForSingleItem: (id: string) => Promise<any>
  markAllAsRead: () => Promise<any>
  deleteAll: () => Promise<any>
}
export class NotificationService extends BaseService {


  async getNotifications(param: any): Promise<any> {
    return this.get(Uris.Notification, param)
      .then((response: { data: any[] }) => {
        response.data = response.data.map(notification => this.mapNotificationEntityToNotificationViewModel(notification).next().value)
        return Promise.resolve(response);
      })
      .catch(error => console.log(error))
  }
  async getUnreadNotification(param: { is_watched: boolean }) {
    return this.get(Uris.Notification, param)
      .then(({ total }) => Promise.resolve(total))
      .catch(error => Promise.reject(error));
  }
  async markAsRead(channelId: string) {
    return this.patch(Uris.Notification, { channel_id: channelId })
      .then(response => response)
      .catch(error => Promise.reject(error))
  }
  async markAsReadForSingleItem(id: string) {
    return await this.patch(Uris.Notification, {
      notificationId: id
    })
  }
  async markAllAsRead() {
    return this.patch(Uris.Notification, { allAsView: true })
      .then(response => response)
      .catch(error => Promise.reject(error))
  }

  async deleteAll() {
    return this.patch(Uris.Notification, { deleteAll: true })
      .then(response => response)
      .catch(error => Promise.reject(error))
  }
  *mapNotificationEntityToNotificationViewModel(notification: HeaderNotification) {
    yield new HeaderNotification(notification);
  }
}


// WEBPACK FOOTER //
// ./src/services/notification.service.ts